import moment from "moment";
import { agruparPareto } from "../Pages/Panel/PresupuestosPU/OrdenesDeProduccionPU/ReporteMotivosPU/reporteMotivos.utils";

const ANCHO = 752;
const CIAN = "#00BFD6";
const PETROLEO = "#006B7A";
const TINTA = "#1A3A4A";
const GRIS = "#8C8C8C";
const PISTA = "#EAF6F8";
const ANCHO_BARRA = 180;

const miles = (n) => (n || 0).toLocaleString("es-MX");

const dinero = (n) => `$${(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const barra =(porcentaje, color) => ({
  canvas: [
    { type: "rect", x: 0, y: 1, w: ANCHO_BARRA, h: 8, r: 4, color: PISTA },
    ...(porcentaje > 0 ? [{ type: "rect", x: 0, y: 1, w: Math.max(4, (porcentaje / 100) * ANCHO_BARRA), h: 8, r: 4, color }] : []),
  ],
});

const tablaEtapa = (grupo) => {
  const encabezados = ["Motivo", "Piezas", "Costo", "%", "% acum.", ""];
  return {
    unbreakable: grupo.motivos.length < 15,
    stack: [
      {
        text: [
          { text: `${grupo.etapa}`, bold: true, color: TINTA, fontSize: 10 },
          { text: `   ${grupo.flujo} · ${miles(grupo.total)} pzs · ${dinero(grupo.costo)}`, color: GRIS, fontSize: 8 },
        ],
        margin: [0, 8, 0, 4],
      },
      {
        table: {
          headerRows: 1,
          widths: ["*", 50, 60, 40, 50, ANCHO_BARRA],
          body: [
            encabezados.map((t) => ({ text: t, style: "encabezado" })),
            ...grupo.motivos.map((motivo) => [
              { text: motivo.motivo, style: "celda", color: motivo.motivoId ? TINTA : GRIS, italics: !motivo.motivoId },
              { text: miles(motivo.piezas), style: "celda", alignment: "right" },
              { text: dinero(motivo.costo), style: "celda", alignment: "right" },
              { text: `${motivo.porcentaje}%`, style: "celda", alignment: "right" },
              { text: `${motivo.porcentajeAcumulado}%`, style: "celda", alignment: "right" },
              barra(motivo.porcentaje, CIAN),
            ]),
          ],
        },
        layout: {
          fillColor: (fila) => (fila === 0 ? "#C5E3F6" : null),
          hLineColor: () => "#E8E8E8",
          vLineColor: () => "#E8E8E8",
          hLineWidth: () => 0.5,
          vLineWidth: () => 0,
        },
      },
    ],
  };
};

const reporteMotivosProduccionPdf = ({ entradas, empresa = {}, descripcionFiltros, usuarioNombre }) => {
  const grupos = agruparPareto(entradas);

  return {
    pageOrientation: "landscape",
    pageSize: "LETTER",
    pageMargins: [20, 20, 20, 28],
    footer: (actual, total) => ({
      columns: [
        { text: `Imprimió: ${usuarioNombre || "—"}`, fontSize: 7, color: GRIS, margin: [20, 6, 0, 0] },
        { text: `${actual} / ${total}`, alignment: "right", fontSize: 7, color: GRIS, margin: [0, 6, 20, 0] },
      ],
    }),
    content: [
      {
        columns: [
          empresa.logo?.base64Completa ? { image: "logo", fit: [64, 64], width: 80 } : { text: "", width: 80 },
          {
            width: "*",
            stack: [
              { text: empresa.nombre || "-", fontSize: 18, bold: true, color: TINTA, alignment: "center" },
              { text: `RFC: ${empresa.rfc || "-"}`, fontSize: 8, color: GRIS, alignment: "center" },
              { text: "REPORTE DE MOTIVOS POR ETAPA", fontSize: 13, bold: true, color: PETROLEO, alignment: "center", margin: [0, 4, 0, 0] },
            ],
          },
          {
            width: 200,
            stack: [
              { text: "FILTROS", fontSize: 7, bold: true, color: GRIS, alignment: "right" },
              { text: descripcionFiltros || "—", fontSize: 8, alignment: "right" },
              { text: "IMPRIMIÓ", fontSize: 7, bold: true, color: GRIS, alignment: "right", margin: [0, 4, 0, 0] },
              { text: usuarioNombre || "—", fontSize: 9, alignment: "right" },
              { text: moment().format("DD/MM/YYYY HH:mm"), fontSize: 8, color: GRIS, alignment: "right" },
            ],
          },
        ],
      },
      { canvas: [{ type: "line", x1: 0, y1: 4, x2: ANCHO, y2: 4, lineWidth: 2, lineColor: CIAN }], margin: [0, 4, 0, 8] },
      { text: "Piezas por motivo de entrada a la etapa", style: "tituloSeccion" },
      ...(grupos.length ? grupos.map(tablaEtapa) : [{ text: "Sin movimientos con estos filtros.", color: GRIS }]),
    ],
    images: empresa.logo?.base64Completa ? { logo: empresa.logo.base64Completa } : {},
    defaultStyle: { font: "Roboto", fontSize: 8 },
    styles: {
      encabezado: { fontSize: 7, bold: true, alignment: "center" },
      celda: { fontSize: 7.5 },
      tituloSeccion: { fontSize: 11, bold: true, color: PETROLEO, margin: [0, 8, 0, 2] },
    },
  };
};

export default reporteMotivosProduccionPdf;
